import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { languageswitchConstants } from '../constants';
import { SocialMediaListRender } from './SocialMediaListRender';


export const SocialMediaListGR = () => {
    const dispatch = useDispatch();
    const s = useSelector(state => state.socialmediaGR.socialmediaListGR);
    const [socialmediaListGR, setSocialmedialListGR] = useState(s);
    const loading = useSelector(state => state.socialmediaGR.loading);
    const e = useSelector(state => state.socialmediaGR.error);
    const [error, setError] = useState(e);
    const d = useSelector(state => state.socialmediaGR.done);
    const [done, setDone] = useState(d);
    var dataLimitPerPage = 15;

    const lang = useSelector(state => state.languageswitch);
    if (lang === languageswitchConstants.GREEK_NR) {
        return <SocialMediaListRender
            stateList={s}
            socialmediaList={socialmediaListGR}
            setSocialmedialList={setSocialmedialListGR}
            loading={loading}
            errorState={e}
            error={error}
            setError={setError}
            doneState={d}
            done={done}
            setDone={setDone}
            dataLimitPerPage={dataLimitPerPage}
        />
    }
}